/*
 * Simfix Assistant - free, fully client-side build.
 * Runs entirely in the shopper's browser: no backend, no AI API, no database, no cost.
 * The product catalogue + grade/size logic + policy answers are bundled (SIMFIX_CATALOGUE
 * is prepended at build time). Handover to a person is by email (mailto). The paid Claude
 * brain can be switched on later without changing this file (data-mode / backend route).
 *
 * Mirrors the tested logic in app/lib/core (matching, retrieval, policy) - kept in plain
 * ES5-ish JS so it runs on any storefront with no build step.
 */
(function () {
  "use strict";
  if (window.__simfixAssistant) return;
  window.__simfixAssistant = true;

  var s = document.currentScript || {};
  var get = function (k, d) {
    return (s.getAttribute && s.getAttribute(k)) || d;
  };
  var cfg = {
    accent: get("data-accent", "#E5601F"),
    position: get("data-position", "bottom-right"),
    label: get("data-launcher-label", "Chat with Simfix"),
    welcome:
      get(
        "data-welcome",
        "Hi, I'm the Simfix assistant. Tell me about your job and I'll help you find the right fastener.",
      ),
    email: get("data-support-email", "contact@simfix.com"),
    catalogueSrc: get("data-catalogue-src", ""),
    name: "Simfix Assistant",
  };

  // The catalogue is ~139KB of the bundle and is only needed once a shopper asks a
  // product question, so it is no longer shipped with the widget. It loads on first
  // open of the panel (well before anyone finishes typing) and any answer that needs
  // it waits for that load. If the catalogue is already on the page, or no source was
  // configured, this degrades to the old inline behaviour.
  var CATALOGUE = window.SIMFIX_CATALOGUE || [];
  var catState = CATALOGUE.length ? 2 : 0; // 0 = idle, 1 = loading, 2 = ready
  var catWaiters = [];

  function catalogueReady(cb) {
    if (catState === 2) { if (cb) cb(); return; }
    if (cb) catWaiters.push(cb);
    if (catState === 1) return;
    if (!cfg.catalogueSrc) { catState = 2; flushCatWaiters(); return; }
    catState = 1;
    var sc = document.createElement("script");
    sc.src = cfg.catalogueSrc;
    sc.async = true;
    sc.onload = function () {
      CATALOGUE = window.SIMFIX_CATALOGUE || [];
      catState = 2;
      flushCatWaiters();
    };
    sc.onerror = function () {
      // Fail safe: the widget still answers policy questions without the catalogue.
      CATALOGUE = [];
      catState = 2;
      flushCatWaiters();
    };
    (document.head || document.documentElement).appendChild(sc);
  }

  function flushCatWaiters() {
    var w = catWaiters;
    catWaiters = [];
    for (var i = 0; i < w.length; i++) { try { w[i](); } catch (e) {} }
  }

  // Each policy carries multiple equivalent phrasings. Facts never vary (no inventing
  // delivery times, refund windows, pricing); only the prose changes so repeat questions
  // don't feel canned.
  var POLICIES = {
    delivery: {
      label: "Delivery policy",
      texts: [
        "Delivery is next working day. Order before 4pm Monday to Friday and it's dispatched the same day; orders after 4pm, or on weekends and bank holidays, are dispatched the next working day. Delivery is free on orders over \u00a350, and full tracking is emailed on every order.",
        "Standard delivery is next working day. The 4pm Mon-Fri cutoff is what matters: order before then and it ships the same day; later than that (including weekends and bank holidays) it goes the next working day. Free over \u00a350, with tracking emailed.",
        "Next-working-day delivery as standard. Cutoff is 4pm Mon-Fri for same-day dispatch; later orders (and weekend or bank holiday orders) ship the next working day. Free delivery over \u00a350, tracking emailed on every order.",
      ],
    },
    returns: {
      label: "Returns policy",
      texts: [
        "No-quibble, no-return: keep the product, there's nothing to post back. You have 30 days to request a refund. For faulty, damaged or incorrect items, contact us within 7 days. Refunds go to the original payment method within 5 to 10 working days, or we'll send a replacement.",
        "Simfix runs a no-return, no-quibble policy - you keep the item. Refund window is 30 days. For anything faulty, damaged or wrong, get in touch within 7 days. Refunds land on the original payment method within 5 to 10 working days, or you can take a replacement instead.",
        "No need to post anything back - it's a no-return refund policy. You have 30 days to request a refund. If something arrives faulty, damaged or incorrect, tell us within 7 days. Refunds to the original payment method in 5 to 10 working days, or a replacement if you'd prefer.",
      ],
    },
    grades: {
      label: "A2 vs A4 guide",
      texts: [
        "A2 (304, also called 18-8) suits general indoor, workshop and most garden or outdoor use. A4 (316) is the marine grade - choose it for coastal, saltwater, swimming-pool or chemical environments for the best corrosion resistance.",
        "A2 (also known as 304 or 18-8) is the all-rounder: indoor, workshop, garden, most outdoor jobs. A4 (316) is the marine-grade upgrade for coastal, saltwater, pool or chemical environments where corrosion resistance matters most.",
        "Two grades. A2 (304 / 18-8) covers indoor, workshop, garden and most outdoor work. A4 (316) is the marine grade - go A4 for anything coastal, saltwater, pool or chemical.",
      ],
    },
    trade: {
      label: "Trade & bulk",
      texts: [
        "Simfix supplies both DIY and larger trade pack sizes. For bigger quantities or a trade price, email us what you need and we'll help.",
        "Both DIY and trade pack sizes are stocked. For larger quantities or trade pricing, email " + cfg.email + " with what you need.",
        "Simfix does DIY packs and bigger trade packs. For bulk quantities or a trade quote, drop the team a line at " + cfg.email + ".",
      ],
    },
    contact: {
      label: "Contact Simfix",
      texts: [
        "You can reach the Simfix team at " + cfg.email + ".",
        "The Simfix team is at " + cfg.email + " - happy to help with anything beyond the chat.",
        "Email the Simfix team: " + cfg.email + ".",
      ],
    },
  };

  // Non-policy response variations. {{email}} is replaced at render time; {{env}} for marine lead.
  var VAR = {
    human: [
      "No problem - the Simfix team can help directly. Email them at {{email}} and they'll get back to you.",
      "Sure thing - the fastest way to a human answer is the Simfix team. Email {{email}} and someone will reply.",
      "Happy to hand you over. The Simfix team is at {{email}} - drop them a note and they'll come back to you.",
      "Of course - reach the Simfix team at {{email}} and they'll pick it up.",
      "Easiest is to email the team direct at {{email}} - they'll come back to you.",
    ],
    order: [
      "To protect your account I can't look up orders here, but the Simfix team can help straight away. Email {{email}} with your order number and they'll get back to you.",
      "Order details are private to your account so I don't pull them up in chat - but the Simfix team does. Email {{email}} with your order number and they'll sort it.",
      "I can't look up order info from this chat (account privacy), but the team can. Drop them a note at {{email}} with your order number and they'll come back to you.",
    ],
    greeting: [
      "Hi! I can help find the right fastener, explain A2 vs A4, or answer about delivery and returns. What are you working on?",
      "Hello - tell me about the job and I'll point you to the right fastener. Or ask about grades (A2 / A4), delivery or returns.",
      "Hey there, happy to help. What are you fixing, building or fastening?",
      "Hi! Three things I'm good at: picking fasteners, grade advice (A2 vs A4), and delivery and returns. Where would you like to start?",
      "Hello! What can I help with - finding the right fastener, grade questions, delivery, or returns?",
    ],
    other: [
      "I can help with finding fasteners, A2 vs A4 grades, delivery or returns. What are you trying to do?",
      "I'm best at fastener picks (just give me the job and size), grade questions (A2 / A4), and policy questions like delivery and returns. Could you tell me a bit more?",
      "Not sure I caught that. I can help pick fasteners, explain grades, or answer delivery and returns - what are you after?",
      "Tell me a bit more and I'll point you the right way - what are you trying to fix, fasten or order?",
      "Could you give me a bit more to go on? I can suggest fasteners, walk through grades, or cover delivery and returns.",
    ],
    productMore: [
      "Tell me a bit more and I'll find the right one - what's it for (indoor, outdoor or marine), and what size do you need?",
      "Couple of quick details and I'm there - what's the environment (indoor / outdoor / marine), and what size (e.g. M6, M8)?",
      "Two things will narrow it down: where it'll live (indoor, outdoor, marine) and the size you need.",
      "What's the application (indoor, outdoor, marine) and the size? I'll find a good fit.",
    ],
    productLead: [
      "Here are some good matches:",
      "A few options that should fit:",
      "These look like a good fit:",
      "Here's what I'd suggest:",
      "Try one of these:",
    ],
    marineLead: [
      "For {{env}} use you'll want A4 (316) marine grade. Here are some matches:",
      "{{env}} use means A4 (316) - the marine grade. These should fit:",
      "For {{env}} work, A4 (316) is the right call. Try these:",
      "{{env}} = A4 (316) territory. These are good options:",
    ],
    thanks: [
      "You're welcome - anything else I can help with?",
      "No problem at all - shout if there's anything else.",
      "Glad to help! More questions?",
      "Anytime - let me know if you need anything else.",
    ],
    bye: [
      "Cheers - happy fixing!",
      "Take care - the Simfix team is at {{email}} if you need them.",
      "Bye for now - good luck with the job!",
      "All the best - shout any time.",
    ],
    bot: [
      "Honest answer: yes, I'm the Simfix assistant - a bot. I can handle picking fasteners and the common questions. If you'd rather a person, the team is at {{email}}.",
      "Yep, I'm a bot - the Simfix assistant. I cover product picks, A2 / A4, delivery and returns. For anything else, {{email}} gets you a human.",
      "Bot, not a human - the Simfix assistant. I handle most product and policy questions. For a person, email {{email}}.",
    ],
    affirm: [
      "Great - what would you like to know?",
      "OK - what can I help with?",
      "Sure - tell me a bit more about what you need.",
      "Alright - what's the question?",
    ],
    negate: [
      "No worries - is there something else I can help with?",
      "OK - anything else? Fasteners, grades, delivery, returns - just ask.",
      "Got it - was there something else you needed?",
    ],
    capabilities: [
      "I can help with three things: picking the right fastener (just tell me the job, environment and size), explaining A2 vs A4 grades, and answering delivery and returns questions. For anything else, the Simfix team is at {{email}}.",
      "Three main things: product recommendations (give me the job and size), grade advice (A2 / A4), and policy questions (delivery, returns). Anything else, the team's at {{email}}.",
      "I'm your fastener shortcut - tell me what you're fixing and I'll suggest products, or ask about grades, delivery, or returns. For orders or anything custom, {{email}}.",
    ],
    price: [
      "Prices are live on each product page - I'd rather not quote a number that might be out of date. I can point you to options, or for trade pricing email {{email}}.",
      "Live pricing is on the product pages - I'll suggest a few that fit and you can check there. For trade or bulk quotes, {{email}} is the route.",
    ],
    stock: [
      "Stock levels show on each product page - I'll suggest some candidates and you can check live availability there. If it's urgent, {{email}} gets the quickest real answer.",
      "Availability is shown live on the product pages. I'll point you at the right options - check stock there, or email {{email}} if you need it confirmed.",
    ],
    hours: [
      "The dispatch cutoff is 4pm Mon-Fri (order before then for same-day dispatch). For specific opening or contact hours, email the team at {{email}}.",
      "Cutoff for same-day dispatch is 4pm Monday-Friday. For office hours or anything else, the team is at {{email}}.",
    ],
    frustrated: [
      "Sorry - I'm clearly not getting you what you need. A person will: email {{email}} and the team will pick it up. Or give me one more go with something concrete, like \"M8 bolts for a gate\".",
      "Apologies, that one's on me. For a proper answer from the team, email {{email}}. Or try me again with the job and a size - \"decking screws, 60mm\" style.",
      "Fair enough - sorry about that. The Simfix team can sort you out at {{email}}. If you want to give me another shot, the job plus a size usually cracks it.",
    ],
    askEnv: [
      "{{type}} I can do. Quick one first - where will they live? Indoor, outdoor or marine changes the grade I'd pick.",
      "Happy to help with {{type}}. Where are they going - indoors, outside, or near the sea? That decides A2 vs A4.",
      "Sure - {{type}}. One question: indoor, outdoor or coastal? The environment picks the grade.",
    ],
  };

  // Anti-repeat picker: never returns the same index twice in a row for a given key.
  var lastPick = {};
  function fill(s, vars) {
    s = String(s).replace(/\{\{email\}\}/g, cfg.email);
    if (vars) {
      if (vars.env) s = s.replace(/\{\{env\}\}/g, vars.env);
      if (vars.type) s = s.replace(/\{\{type\}\}/g, vars.type);
    }
    return s;
  }
  function pickFrom(key, arr) {
    if (arr.length === 1) return arr[0];
    var last = lastPick[key], i;
    do { i = Math.floor(Math.random() * arr.length); } while (i === last);
    lastPick[key] = i;
    return arr[i];
  }
  function pick(key, vars) {
    var arr = VAR[key];
    if (!arr || !arr.length) return "";
    if (arr.length === 1) return fill(arr[0], vars);
    var last = lastPick[key], i;
    do { i = Math.floor(Math.random() * arr.length); } while (i === last);
    lastPick[key] = i;
    return fill(arr[i], vars);
  }
  function pickPolicy(name) {
    var pol = POLICIES[name] || POLICIES.contact;
    var arr = pol.texts;
    if (arr.length === 1) return { text: arr[0], source: pol.label };
    var key = "pol:" + name;
    var last = lastPick[key], i;
    do { i = Math.floor(Math.random() * arr.length); } while (i === last);
    lastPick[key] = i;
    return { text: arr[i], source: pol.label };
  }

  // ---- conversation context for follow-up questions ----
  // Track the last substantive intent so vague follow-ups ("how do I do this",
  // "tell me more", "go on") can be answered against the previous topic instead
  // of falling through to a generic "what are you working on?".
  var ctx = { lastIntent: null, lastText: null, slots: null, askedEnv: false, lastRecs: null };

  // Elaboration answers keyed by the topic the user was just discussing.
  // These are NEXT-STEP / HOW-TO answers, not restatements of the original policy.
  // {{email}} is replaced at render time.
  var FOLLOWUP = {
    "policy:returns": [
      "Two routes depending on what's happened.\n\nChange of mind (within 30 days): email {{email}} with your order number. You keep the product, refund goes to your original payment method in 5 to 10 working days.\n\nFaulty, damaged or wrong item (within 7 days): email {{email}} with your order number and a photo if you can. The team will refund or send a replacement.",
      "Email {{email}} with your order number.\n\nIf it's a change of mind (within 30 days), that's all you need - refund to your original payment method, nothing to post back.\n\nIf it's faulty, damaged or wrong (within 7 days), mention what's happened (a photo helps) and the team will refund or replace.",
    ],
    "policy:delivery": [
      "Tracking is emailed automatically once your order ships. The 4pm Mon-Fri cutoff is what matters for same-day dispatch - after that, weekends or bank holidays, it goes the next working day. If your order's late or something looks wrong, email {{email}} with your order number.",
      "Same-day dispatch needs the order placed before 4pm Monday to Friday. After that, or weekends and bank holidays, dispatch is the next working day. Free delivery over \u00a350, tracking emailed automatically. If anything's off, {{email}} is the quickest route.",
    ],
    "policy:grades": [
      "Rule of thumb:\n\nIndoor, workshop, garden or general outdoor work -> A2 (304) is fine.\nCoastal, saltwater, swimming pool or chemical -> go A4 (316).\n\nTell me the environment and the size you need and I'll suggest some products.",
      "If you tell me the environment (indoor, outdoor, marine, chemical) and the size, I'll point you at the right grade and some matching products.",
    ],
    "policy:trade": [
      "Email {{email}} with what you need - sizes, grade (A2 or A4), quantities, any specific standards - and the team will come back with trade pricing.",
    ],
    "policy:contact": [
      "Email is the fastest route: {{email}}. For trade or bulk quotes, include sizes, grade and quantities so the team can come back with a number.",
    ],
    human: [
      "There's an Email button just above this message - tap it and it opens a new email to {{email}} with your question already in the body. Or write to that address directly.",
    ],
    order: [
      "Email {{email}} with your order number. The team can look it up against your account and come back with the answer.",
    ],
    product: [
      "If you tell me the environment (indoor, outdoor, marine) and the size (e.g. M6, M8, M10), I'll narrow it down. Each product page also has the full spec, stock and live price.",
      "A bit more detail and I can shortlist them - size (M6, M8 etc) and where it's going (indoor, outdoor, marine).",
    ],
    bot: [
      "Three things I'm good at: picking fasteners, A2 vs A4, and delivery and returns. What are you working on?",
    ],
    price: [
      "Live prices are on each product page - that way you're always seeing the current number. For trade or bulk, email {{email}} with sizes, grade and quantities.",
    ],
    stock: [
      "Stock is shown live on each product page. If you need something confirmed or you're after a specific quantity, {{email}} is the route.",
    ],
    hours: [
      "Cutoff is 4pm Mon-Fri for same-day dispatch. For office hours or anything else, {{email}} is the quickest route.",
    ],
    greeting: [
      "I can help with three things: picking the right fastener (give me the job and size), grade advice (A2 vs A4), or delivery and returns. Where would you like to start?",
    ],
    capabilities: [
      "Try me with something concrete - e.g. \"an M8 bolt for an outdoor gate\" or \"what grade for a boat trailer?\".",
    ],
  };

  // Does this message look like a follow-up to the previous topic rather than a new question?
  function isFollowUp(x) {
    if (!x || x.length < 2) return false;
    return /^(how|what|when|where|why|which)\b/.test(x) ||
           /^(tell me|show me|explain|elaborate|details|go on|continue|and\b|so\b|now\b|next\b|more\b)/.test(x) ||
           /^(can|could|do|does|is|are|should|will) (i|you|it|they|that|this|we)\b/.test(x) ||
           /^(ok|okay) (then|so|how|what|now|and)\b/.test(x);
  }

  function pickFollowup(intent) {
    var arr = FOLLOWUP[intent];
    if (!arr || !arr.length) return null;
    if (arr.length === 1) return fill(arr[0]);
    var key = "fu:" + intent;
    var last = lastPick[key], i;
    do { i = Math.floor(Math.random() * arr.length); } while (i === last);
    lastPick[key] = i;
    return fill(arr[i]);
  }

  // ---- light typo/contraction normalisation so misspellings still classify ----
  var TYPO_FIXES = [
    [/\bwhats\b/g, "what is"], [/\bhows\b/g, "how is"], [/\bwheres\b/g, "where is"],
    [/\bdeliv(?:ary|rey|ry|eray)\b/g, "delivery"], [/\bdelievery\b/g, "delivery"],
    [/\bstainles\b/g, "stainless"], [/\bstanless\b/g, "stainless"],
    [/\bsrews?\b/g, "screws"], [/\bscews?\b/g, "screws"],
    [/\brefnd\b/g, "refund"],
    [/\brecieve/g, "receive"],
    [/\bguarentee\b/g, "guarantee"], [/\bgarantee\b/g, "guarantee"],
    [/\bwarrenty\b/g, "warranty"],
    [/\bavaliable\b/g, "available"], [/\bavailble\b/g, "available"],
    // Trade-speak synonyms mapped onto catalogue vocabulary
    [/\blag (bolts?|screws?)\b/g, "coach screws"],
    [/\btek screws?\b/g, "self drilling screws"],
    [/\bsocket (head )?(cap )?(screws?|bolts?)\b/g, "socket cap screws"],
    [/\ballen (key )?bolts?\b/g, "socket cap screws"],
    [/\bpenny washers?\b/g, "repair washers"],
    [/\bstudding\b/g, "threaded rod"], [/\ball ?thread\b/g, "threaded rod"],
  ];
  function norm(t) {
    var x = lc(t).replace(/[\u2018\u2019]/g, "'").trim();
    for (var i = 0; i < TYPO_FIXES.length; i++) x = x.replace(TYPO_FIXES[i][0], TYPO_FIXES[i][1]);
    return x;
  }

  // ---- application know-how: real jobs mapped to advice + search hints ----
  // note is prepended to product recommendations; env feeds the grade logic.
  var APPLICATIONS = [
    { re: /deck(ing|s)?\b|deck board/, env: "outdoor", terms: "decking wood screws",
      note: "For decking you want stainless decking or wood screws - no black rust streaks bleeding out of the timber. A2 is fine inland; go A4 if you're within a couple of miles of the coast." },
    { re: /fenc(e|ing)|trellis/, env: "outdoor", terms: "wood screws coach",
      note: "Fencing lives out in the weather full-time, so stainless earns its keep - A2 inland, A4 coastal." },
    { re: /\bgates?\b|hinge/, env: "outdoor", terms: "coach bolts nuts washers",
      note: "Gates and hinges take repeated swing loads - coach bolts with nyloc nuts and washers hold far better than screws alone." },
    { re: /\bsheds?\b|summer ?house|log cabin/, env: "outdoor", terms: "wood screws",
      note: "Shed builds do best with stainless wood screws - they won't streak the cladding after the first winter." },
    { re: /pergola|gazebo|arbour|car ?port/, env: "outdoor", terms: "coach bolts wood screws",
      note: "For pergola-type frames, coach bolts at the joints and wood screws for the rest is the usual recipe." },
    { re: /raised beds?|planters?/, env: "outdoor", terms: "wood screws",
      note: "Raised beds stay damp year-round - stainless won't leach rust into the soil or stain the boards." },
    { re: /greenhouse|polytunnel|cold frame/, env: "outdoor", terms: "machine screws nuts",
      note: "Greenhouse frames usually take small machine screws and nuts - stainless handles the constant condensation." },
    { re: /bathroom|shower|wet ?room|towel rail/, env: "indoor", terms: "screws",
      note: "Bathrooms are damp enough to rust plain steel fixings - stainless keeps everything streak-free. A2 does the job; A4 if it gets properly wet." },
    { re: /trailer|towbar|caravan/, env: "marine", terms: "bolts nyloc nuts washers",
      note: "Trailers cop road spray and salt - A4 (316) with nyloc nuts so nothing shakes loose on the road." },
    { re: /hot ?tub|jacuzzi|swimming ?pool|pool ?side/, env: "corrosive", terms: "screws bolts",
      note: "Chlorine is brutal on metal - around pools and hot tubs it's A4 (316) only." },
    { re: /roof(ing)?\b|guttering|fascia|soffit|cladding/, env: "outdoor", terms: "screws",
      note: "Roofline and cladding fixings are exposed year-round - stainless won't bleed rust down the boards. A4 near the coast." },
    { re: /bird ?(box|table|feeder)|garden furniture|picnic (table|bench)/, env: "outdoor", terms: "wood screws",
      note: "Garden woodwork is a classic stainless job - no rust stains down the timber after the first wet month." },
    { re: /swing|climbing frame|tree ?house|play ?(house|set|ground)|trampoline/, env: "outdoor", terms: "coach bolts nyloc nuts",
      note: "For play equipment, use bolts with nyloc nuts rather than screws and check them each season. For anything structural or safety-critical, run it past the team first: {{email}}." },
    { re: /\btables?\b|\bdesks?\b|\bchairs?\b|bed ?frame|flat ?pack|furniture/, env: "indoor", terms: "machine screws nuts washers wood screws",
      note: "For furniture, machine screws with nuts and washers give a joint you can take apart later; wood screws for fixed joints. Small sizes (M4 to M6) cover most furniture work." },
    { re: /wardrobe|cabinet|cupboard|drawers?\b|shelf|shelv(es|ing)|skirting/, env: "indoor", terms: "wood screws",
      note: "Cabinet, shelving and trim work is mostly small wood screws - stainless means no rust spotting around the heads over time." },
    { re: /mirror|picture (frame|rail)|curtain (pole|rail|track)|blinds?\b|radiator/, env: "indoor", terms: "screws",
      note: "Light indoor fixings - small stainless screws keep fittings spot-free. Going into masonry, you'll also need the right wall plug for the screw size." },
    { re: /tv (bracket|mount|wall)|wall mount/, env: "indoor", terms: "bolts washers",
      note: "TV brackets usually take machine bolts and washers into the bracket, plus the right anchors for your wall type. Check the bracket's stated bolt size and match the M size." },
    { re: /\bbikes?\b|motorbike|motorcycle|scooter/, env: "outdoor", terms: "machine screws bolts nyloc",
      note: "Bike work is metric machine threads - match the M size and use nylocs where there's vibration. A4 if it lives outside." },
  ];
  function detectApp(x) {
    for (var i = 0; i < APPLICATIONS.length; i++) if (APPLICATIONS[i].re.test(x)) return APPLICATIONS[i];
    return null;
  }

  // ---- semantic FAQ bank: real fastener knowledge for specific questions ----
  // Regexes are deliberately question-shaped so product queries like "rust proof
  // screws for decking" still fall through to product matching. topic controls what
  // a vague follow-up elaborates on; email adds the handover button.
  var FAQ = [
    { topic: "policy:grades",
      re: /\b(will|would|does|do|can|is|are)\b[^.?!]*\b(rust|corrode|go rusty|tarnish|discolour)/,
      a: ["Stainless is corrosion-resistant all the way through - there's no coating to chip off like zinc plating. A2 shrugs off normal UK weather; salt air and chlorine are the exceptions, which is what A4 (316) is for. Just avoid contaminating it with carbon-steel tools or wire wool."] },
    { topic: "policy:grades",
      re: /what (does|do|is)\b[^.?!]*\bm ?\d{1,2}\b[^.?!]*(mean|stand for)|\bwhat is an? m ?\d{1,2}\b/,
      a: ["The M number is the thread's outer diameter in millimetres - M8 is 8mm across the thread. A size like M8 x 40 means 8mm diameter, 40mm long. Tell me the size you're after and I'll find matches."] },
    { topic: "policy:grades",
      re: /\b(18-?8|304|316|a2|a4)\b[^.?!]*\b(mean|stand for)\b|what (is|are|does) (a2|a4|304|316|18-?8)\b/,
      a: ["A2 and 304 (also written 18-8) are the same steel - the general-purpose stainless. A4 and 316 are the same too, with added molybdenum for salt and chemical resistance. That's why A4 is the marine grade."] },
    { topic: "policy:grades",
      re: /alumini?um|galvanic|dissimilar metals?|mixed metals?/,
      a: ["Stainless against aluminium can set up galvanic corrosion when damp - the aluminium corrodes, not the fastener. Isolate the two with a washer or a smear of barrier grease and it's a non-issue; that's standard practice in marine work."] },
    { topic: "policy:grades",
      re: /magnet/,
      a: ["Mostly non-magnetic. A2 and A4 are austenitic stainless, so a magnet barely sticks - though cold-formed parts like rolled threads can be very slightly magnetic. It's normal and doesn't affect corrosion resistance."] },
    { topic: "policy:grades",
      re: /galvani[sz]ed|zinc[- ]?plated|\bbzp\b/,
      a: ["Galvanised and zinc-plated fasteners are steel with a sacrificial coating - once it's chipped or worn through, they rust. Stainless is the same metal all the way through, so it keeps its resistance for life. Outdoors, stainless wins long-term."] },
    { re: /spanner|socket size|hex size|what size (spanner|socket)/,
      a: ["Standard spanner sizes for metric hex heads and nuts: M5 = 8mm, M6 = 10mm, M8 = 13mm, M10 = 17mm, M12 = 19mm."] },
    { re: /pilot hole|pre[- ]?drill/,
      a: ["Rule of thumb for wood screws: pilot drill roughly the screw's core diameter (the solid centre inside the thread) - a touch smaller in softwood, full core in hardwood. Always pilot near board ends to stop splitting."] },
    { re: /nyloc[^.?!]*\b(what|how|work|reuse|re[- ]?use)|\b(what|how|can i)\b[^.?!]*\bnyloc/,
      a: ["A nyloc has a nylon collar that grips the thread so it won't vibrate loose - ideal for gates, trailers and anything that moves. The collar loses grip each time it's removed, so fit a fresh one after taking it off."] },
    { re: /coach (bolt|screw)[^.?!]*\b(vs|or|difference)|difference[^.?!]*coach/,
      a: ["Coach bolt: domed head with a square shoulder, goes through a clearance hole and takes a nut and washer - best where you can reach both sides. Coach screw: chunky hex-head wood screw that bites straight into timber - for when you can only get at one side."] },
    { re: /set ?screws?[^.?!]*\b(what|vs|or|difference)|\b(what|difference)\b[^.?!]*set ?screws?/,
      a: ["A set screw is a bolt threaded along its full length, so it clamps tight at any depth. Part-threaded bolts have a plain shank, which is stronger across a joint. Full thread for adjustability, part thread for shear strength."] },
    { re: /why[^.?!]*washers?|do i need[^.?!]*washers?|what[^.?!]*washers?[^.?!]*for|washers?[^.?!]*(purpose|point of)/,
      a: ["Washers spread the clamping load so the head or nut doesn't dig into the surface - essential on timber and soft metals. Spring washers add grip against vibration. Cheap insurance for a better joint."] },
    { re: /self[- ]?tapp(ing|ers?)?[^.?!]*\b(vs|or|difference|wood)|difference[^.?!]*self[- ]?tapp/,
      a: ["Wood screws have a coarse thread and tapered point for timber. Self-tappers cut their own thread in sheet metal or plastic through a pilot hole. Use each for its own material - a wood screw won't grip steel, and a self-tapper tears wood fibres."] },
    { email: true,
      re: /\blift(ing)?\b|overhead|rigging|hoist|winch\b/,
      a: ["Important one: standard fasteners, including eye bolts, are not rated for lifting or overhead loads. Load-rated work needs certified lifting gear with documentation. Email the team at {{email}} with what you're planning and they'll point you the right way."] },
    { email: true,
      re: /torque|how tight|over[- ]?tighten/,
      a: ["Snug plus a small turn is right for most jobs - stainless galls (seizes) if you run it in fast and hot, so go steady and don't gun it with an impact driver. For critical torque figures, email {{email}} with the size and grade."] },
    { topic: "policy:returns", email: true,
      re: /guarantee|warranty/,
      a: ["That's covered by the returns policy: 30 days no-quibble refunds, and 7 days to report anything faulty, damaged or incorrect for a refund or replacement. If something's not right, email {{email}} with your order number."] },
    { email: true,
      re: /ireland|europe|international|abroad|overseas|outside (the )?uk|channel islands|isle of man|highlands and islands/,
      a: ["For delivery outside mainland UK, email the team at {{email}} with your address and they'll confirm what's possible for your order."] },
    { email: true,
      re: /\bvat\b|invoice|receipt|payment method|paypal|klarna|apple pay|google pay/,
      a: ["Checkout shows the payment options available for your order. For VAT invoices or receipts, email {{email}} with your order number and the team will send one over."] },
    { email: true,
      re: /snapp?(ed)?\b|sheared|stripped (thread|head)|rounded (off|out)/,
      a: ["A snapped or stripped fastener usually means over-torque, galling, or a size too small for the load. Step up a size or grade, pilot correctly, and drive steadily. If it keeps happening, email {{email}} with the job details and the team will spec it properly."] },
    { email: true,
      re: /threaded rods?|threaded bars?/,
      a: ["Threaded rod isn't something I can see in the standard web range - email {{email}} with the diameter, length and grade you need and the team will sort what's possible."] },
    { email: true,
      re: /plasterboard|drywall|masonry|\bbrick\b|concrete|wall plugs?|rawl ?plugs?|breeze ?block/,
      a: ["Into masonry or plasterboard, the anchor does the holding - Simfix covers the stainless screws and machine threads that go into them. Match the screw size to the plug's stated size (a brown plug typically takes a 5-6mm screw). For heavy or structural loads, email {{email}} first."] },
  ];
  function matchFaq(x) {
    for (var i = 0; i < FAQ.length; i++) if (FAQ[i].re.test(x)) return i;
    return -1;
  }

  // ---- language -> structured attributes (port of app/lib/core/matching) ----
  function lc(t) {
    return (t || "").toLowerCase();
  }
  function detectGrade(t) {
    t = lc(t);
    if (/\ba4\b|316/.test(t)) return "A4";
    if (/\ba2\b|304|18-?8/.test(t)) return "A2";
    return null;
  }
  function detectEnv(t) {
    t = lc(t);
    if (/marine|boat|yacht|coast|seaside|\bsea\b|seafront|offshore|salt|harbour|dock|pontoon/.test(t)) return "marine";
    if (/chemical|pool|chlorine|acid|food processing/.test(t)) return "corrosive";
    if (/outdoor|outside|garden|fence|fencing|decking|gate|shed|exterior|patio|exposed/.test(t)) return "outdoor";
    if (/workshop|garage|machine shop/.test(t)) return "workshop";
    if (/indoor|inside|kitchen|bathroom|interior|furniture|cabinet/.test(t)) return "indoor";
    return null;
  }
  function detectType(t) {
    t = lc(t);
    if (/\bscrews?\b|wood screw|machine screw|self.?tapp|coachscrew|driller/.test(t)) return "Screws";
    if (/\bbolts?\b|coach bolt|cup square|eye bolt|set ?screw/.test(t)) return "Bolts";
    if (/\bnuts?\b|nyloc|dome nut|lock ?nut/.test(t)) return "Nuts";
    if (/\bwashers?\b|spring washer|flat washer|form [ab]/.test(t)) return "Washers";
    return null;
  }
  function normSize(t) {
    var m = /\bm\s?(\d{1,2}(?:\.\d)?)\b/i.exec(t || "");
    if (!m) {
      // "8mm bolts" reads as a diameter when a small mm number sits right before a fastener word
      m = /\b(\d{1,2}(?:\.\d)?)\s?mm\s+(?:dia(?:meter)?\s+)?(?:screws?|bolts?|nuts?|washers?|thread)/i.exec(t || "");
      if (m && Number(m[1]) > 12) m = null;
    }
    if (!m) return null;
    var n = Number(m[1]);
    if (!isFinite(n) || n <= 0 || n > 64) return null;
    return "M" + (n % 1 === 0 ? String(n) : String(n));
  }
  function extractLength(t) {
    var pats = [/(\d{1,3})\s?mm\b/i, /\bx\s?(\d{1,3})\b/i, /\bby\s?(\d{1,3})\b/i];
    for (var i = 0; i < pats.length; i++) {
      var m = pats[i].exec(t || "");
      if (m) {
        var n = Number(m[1]);
        if (n > 0 && n <= 1000) return n;
      }
    }
    return null;
  }
  function attrs(t) {
    var size = normSize(t);
    var length = extractLength(t);
    // "8mm bolts": the 8 was the diameter, not a length
    if (size && length != null && !/\bm\s?\d/i.test(t) && ("M" + length) === size) length = null;
    return {
      grade: detectGrade(t),
      size: size,
      length: length,
      env: detectEnv(t),
      type: detectType(t),
    };
  }

  function classify(t) {
    var x = norm(t);
    // Questions about the last set of recommendations ("why", "which one", "shorter")
    if (ctx.lastRecs) {
      if (/^(why\b|how come)/.test(x) && x.length < 40 && !/deliver|return|refund|price|stock|order/.test(x))
        return "explainRecs";
      if (/^which (one|of these|is best|should i|would you)|^what('s| is) the difference between (these|those|them)/.test(x))
        return "compareRecs";
      if (/^(longer|shorter|bigger|smaller|larger|wider|narrower|too (long|short|big|small))\b/.test(x))
        return "refine";
    }
    // A bare number mid-product-chat ("8") means a size or length
    if ((ctx.slots || ctx.lastRecs) && /^m? ?\d{1,3} ?(mm)?$/.test(x)) return "product";
    var base = baseClassify(x);
    // Promote vague follow-ups into elaborations of the previous topic
    if (base === "other" && ctx.lastIntent && isFollowUp(x)) {
      return "followup:" + ctx.lastIntent;
    }
    return base;
  }

  function baseClassify(x) {
    // Frustration first: apologise and hand over rather than looping generic replies
    if (/\b(useless|pointless|rubbish|terrible|awful|stupid|ridiculous|waste of (my )?time|not helping|no help at all|doesn'?t help|not what i asked|wrong answer|you don'?t understand|not listening|isn'?t working|fed up)\b/.test(x))
      return "frustrated";
    // "are you a bot?" - distinct from a transfer request: be honest, don't pretend to hand over
    if (/\bare you (a )?(bot|robot|ai|human|real|real (person|human)|person)\b|\bis this (a )?(bot|ai|chatbot|robot)\b|\bbot or (human|person)\b|\b(talking|speaking) to a (bot|robot|machine|computer|human|person)\b/.test(x))
      return "bot";
    // Handover to a person
    if (/\b(human|agent|person|representative|rep|operator|advisor|adviser)\b|\bcustomer (service|support|care)\b|\blive (agent|chat|support|help)\b|\b(speak|talk|chat)\b[^.?!]*\b(to|with)\b/.test(x) ||
        /\bput me through\b|\btransfer me\b|\bconnect me\b|\bget me (someone|support|help)\b|\bcontact (someone|a person|the team)\b|\b(simfix|support|your|the) team\b/.test(x))
      return "human";
    // Order lookup
    // "no" needs its own boundary or "order now" reads as "order no"; bare "dispatch"
    // is a delivery-policy word, so only "my order ... dispatched" lands here
    if (/\bmy order\b|order\s*(number|no\b|#)|track(ing)?\b|where('?s| is)\s+my\b/.test(x) ||
        /\bmy (parcel|package)\b|\bmy delivery\b[^.?!]*\b(hasn'?t|not|late|missing|come|arrived|where)/.test(x))
      return "order";
    // Short conversational replies (negate first so "no thanks" isn't a thank-you)
    if (/^(no|nope|nah|no thanks|not now|no ta)[.! ]*$/.test(x)) return "negate";
    if (x.length <= 28 && /\b(thanks?|thank (you|u)|thankyou|thx|ty|cheers|appreciated|appreciate it|nice one|ta)\b/.test(x)) return "thanks";
    if (/^(bye|goodbye|cya|see ya|see you|later|catch you later|good ?night|night|take care)\b/.test(x)) return "bye";
    if (/^(yes|yeah|yep|yup|ok|okay|sure|cool|alright|fine|sounds good|please|yes please|go ahead|go on|do it)[.! ]*$/.test(x)) return "affirm";
    // Meta: what can you do
    if (/\b(what can you (do|help with)|what are you|who are you|can you help|what do you do|how does this work|how can you help)\b|^help$/.test(x)) return "capabilities";
    // Trade / bulk first - "trade pricing" should go to policy:trade, not generic price
    if (/\b(trade|bulk|wholesale)\b|\blarge (quantit|order)|\bjob lot\b/.test(x)) return "policy:trade";
    // "how much is delivery" is a delivery question, not a product-price one
    if (/\b(deliver|shipping|postage)[a-z]*\b[^.?!]*\b(cost|price|charge|how much|free)\b|\b(cost|price|charge|how much|free)\b[^.?!]*\b(deliver|shipping|postage)/.test(x))
      return "policy:delivery";
    // Commerce-but-not-in-catalogue questions
    if (/\b(price|cost|how much|cheap|expensive|quote|pricing|discount)\b/.test(x)) return "price";
    if (/\b(in stock|stock level|availability|got any|do you (have|stock)|available|out of stock)\b/.test(x)) return "stock";
    if (/\b(opening hours|open today|what time (are you|do you) (open|close)|when (are you |do you )?(open|close)|business hours|store hours)\b|^hours$/.test(x)) return "hours";
    // Returns before product: "faulty screws" is a complaint, not a shopping query
    if (/\b(return|refund|faulty|damag|wrong item|broken|money back)/.test(x)) return "policy:returns";
    // Semantic FAQ bank - before product so "what does M8 mean" isn't treated as a size query
    var fq = matchFaq(x);
    if (fq >= 0) return "faq:" + fq;
    // Existing product / policy paths
    var a = attrs(x);
    if (a.type || a.size || a.length != null) return "product";
    // No trailing \b so "delivery", "delivered", "shipping", "arrives" all match
    if (/\b(deliver|shipping|postage|dispatch|how long|when will|arriv|cut ?off)/.test(x) ||
        /\bwhen\b[^.?!]*\b(come|arrive|turn up|get here)/.test(x) || /\bwhen (would|will|do) i (get|receive)\b/.test(x))
      return "policy:delivery";
    if (/\b(a2|a4|304|316|grades?|stainless)\b|\bdifference between\b/.test(x)) return "policy:grades";
    if (/\b(contact|email|phone|call)\b|where are you (based|located)|\baddress\b/.test(x)) return "policy:contact";
    if (a.env || detectApp(x) ||
        /\b(screws?|bolts?|nuts?|washers?|fasteners?|fixings?|fix|attach|fasten|recommend|suggest|which|looking for|need)\b/.test(x))
      return "product";
    if (/^\s*(hi|hello|hey|hiya|howdy|yo|morning|afternoon|evening|good (morning|afternoon|evening))\b/.test(x)) return "greeting";
    return "other";
  }

  // ---- ranking (port of app/lib/core/retrieval) ----
  function rank(a, text) {
    var needsMarine = a.env === "marine" || a.env === "corrosive";
    var terms = lc(text).split(/[^a-z0-9]+/).filter(function (w) { return w.length > 2; });
    var scored = [];
    for (var i = 0; i < CATALOGUE.length; i++) {
      var p = CATALOGUE[i];
      if (needsMarine && p.grade !== "A4") continue;
      var match = 0, total = 0, reasons = [];
      if (a.grade) { total += 3; if (p.grade === a.grade) { match += 3; reasons.push("Grade " + p.grade); } }
      if (a.type) { total += 2; if (p.type === a.type) { match += 2; reasons.push(p.type); } }
      if (a.size) { total += 3; if (p.sizeMetric === a.size) { match += 3; reasons.push("Size " + a.size); } }
      if (a.length != null) { total += 2; if (p.lengthMm === a.length) { match += 2; reasons.push(a.length + "mm"); } }
      if (a.env) { total += 2; if ((p.environments || []).indexOf(a.env) >= 0) { match += 2; reasons.push("For " + a.env); } }
      var attrScore = total ? match / total : 0;
      var hay = lc(p.title + " " + (p.application || "") + " " + p.type + " " + p.grade);
      var kw = 0; for (var k = 0; k < terms.length; k++) if (hay.indexOf(terms[k]) >= 0) kw++;
      var kwScore = terms.length ? kw / terms.length : 0;
      var score = 0.6 * attrScore + 0.4 * kwScore;
      if (score > 0) scored.push({ p: p, score: score, reasons: reasons });
    }
    scored.sort(function (x, y) { return y.score - x.score; });
    return scored.slice(0, 3);
  }

  // ---- compose an answer (no LLM) ----
  function updateCtx(intent, message) {
    // Transient intents must not clobber the substantive topic, so chains like
    // "refund -> how -> thanks -> and one more?" still resolve against returns.
    var transient = { thanks: 1, bye: 1, affirm: 1, negate: 1, frustrated: 1,
                      explainRecs: 1, compareRecs: 1, refine: 1 };
    if (transient[intent]) return;
    if (intent.indexOf("followup:") === 0) intent = intent.substring("followup:".length);
    if (intent.indexOf("faq:") === 0) {
      var fe = FAQ[Number(intent.slice(4))];
      intent = (fe && fe.topic) || "capabilities";
    }
    ctx.lastIntent = intent;
    ctx.lastText = message;
  }

  // Two questions in one message ("delivery and returns") get both answers.
  function splitCompound(message) {
    var x = norm(message);
    if (x.length < 12) return null;
    var m = /^(.{4,}?)\s+(?:and also|and|also|plus|as well as|&)\s+(.{4,})$/.exec(x);
    return m ? [m[1], m[2]] : null;
  }
  function joinable(i) {
    return /^(policy:|faq:)/.test(i) ||
      { product: 1, human: 1, order: 1, price: 1, stock: 1, hours: 1, capabilities: 1, bot: 1 }[i] === 1;
  }

  function answer(message) {
    var parts = splitCompound(message);
    if (parts) {
      var iA = classify(parts[0]), iB = classify(parts[1]);
      // "nuts and bolts" is one product query, not two questions - don't split those
      if (iA !== iB && joinable(iA) && joinable(iB) && !(iA === "product" && iB === "product")) {
        var rA = compose(iA, parts[0]);
        updateCtx(iA, parts[0]);
        var rB = compose(iB, parts[1]);
        updateCtx(iB, parts[1]);
        return {
          text: rA.text + "\n\n" + rB.text,
          cards: rA.cards || rB.cards,
          email: rA.email || rB.email,
          mailtoBody: message,
          chips: rB.chips || rA.chips,
          source: rA.source || rB.source,
        };
      }
    }
    var intent = classify(message);
    var res = compose(intent, message);
    updateCtx(intent, message);
    return res;
  }

  function compose(intent, message) {
    // Questions about the last recommendations
    if (intent === "explainRecs" || intent === "compareRecs" || intent === "refine") {
      var lr = ctx.lastRecs;
      if (!lr) return { text: pick("other") };
      if (intent === "refine")
        return { text: "Easy enough - give me the length in mm (or a different M size) and I'll re-match. Rule of thumb: the fastener should go about two-thirds into the material you're fixing to." };
      if (intent === "compareRecs")
        return { text: "They're the same family - the real difference is the size on each chip (diameter x length). Pick the length that suits your material: roughly two-thirds into what you're fixing to, without poking out the back. Tell me the thickness and I'll pick one." };
      // explainRecs: rebuild the reasoning from the slots that drove the ranking
      var sl = lr.slots || {};
      var why = [];
      if (sl.env === "marine" || sl.env === "corrosive") why.push("salt or chlorine means A4 (316) - the grade that survives that environment");
      else if (sl.env === "outdoor") why.push("outdoor use points to stainless that can live in the weather without staining");
      else if (sl.env === "indoor" || sl.env === "workshop") why.push("for indoor work A2 (304) covers everything you need");
      if (sl.grade) why.push("you asked for " + sl.grade + " so I kept to that grade");
      if (sl.size) why.push("they're " + sl.size + " to match the size you gave");
      if (sl.type) why.push("they're " + sl.type.toLowerCase() + ", which is what you asked about");
      if (lr.app) why.push("and that's the usual pick for the job you described");
      var joined = why.join("; ");
      var wtxt = why.length
        ? "Fair question. " + joined.charAt(0).toUpperCase() + joined.slice(1) + "."
        : "They were the closest matches to what you typed.";
      return { text: wtxt + "\n\nIf something's off, tell me what to change - size, grade, or where it's going." };
    }
    // Follow-up elaboration of a prior topic
    if (intent.indexOf("followup:") === 0) {
      var fuKey = intent.substring("followup:".length);
      var fuText = pickFollowup(fuKey);
      if (fuText) return { text: fuText, email: true, mailtoBody: message };
      // No elaboration registered - fall back to a fresh policy / pick
      if (fuKey.indexOf("policy:") === 0) return pickPolicy(fuKey.split(":")[1]);
      return { text: pick("other") };
    }
    if (intent.indexOf("faq:") === 0) {
      var fe = FAQ[Number(intent.slice(4))];
      var fres = { text: fill(pickFrom(intent, fe.a)), source: "Fastener know-how" };
      if (fe.email) { fres.email = true; fres.mailtoBody = message; }
      return fres;
    }
    if (intent === "frustrated")
      return { text: pick("frustrated"), email: true, mailtoBody: message };
    if (intent === "human" || intent === "order")
      return { text: pick(intent), email: true, mailtoBody: message };
    if (intent === "bot")
      return { text: pick("bot"), email: true, mailtoBody: message };
    if (intent === "price" || intent === "stock" || intent === "hours") {
      // A price/stock question that names a product gets the matching cards too
      if (intent !== "hours") {
        var pa = attrs(norm(message));
        if (pa.type || pa.size) {
          var pr = rank(pa, norm(message));
          if (pr.length) {
            ctx.lastRecs = { recs: pr, slots: pa, app: null };
            return { text: pick(intent), cards: pr, email: true, mailtoBody: message };
          }
        }
      }
      return { text: pick(intent), email: true, mailtoBody: message };
    }
    if (intent === "thanks" || intent === "bye" || intent === "affirm" ||
        intent === "negate" || intent === "capabilities")
      return { text: pick(intent) };
    if (intent.indexOf("policy:") === 0) {
      var pname = intent.split(":")[1];
      var pres = pickPolicy(pname);
      var pchips = {
        delivery: ["Returns policy", "Help me pick a fastener"],
        returns: ["How do I claim?", "Delivery policy"],
        grades: ["Something for outdoor use", "Something for marine use"],
      }[pname];
      if (pchips) pres.chips = pchips;
      return pres;
    }
    if (intent === "greeting") return { text: pick("greeting") };
    if (intent === "other") return { text: pick("other") };
    // product - with slot memory so details can arrive over several messages
    var x = norm(message);
    // A bare number reply ("8") means M8 if it's a plausible diameter, else a length
    var bare = /^m? ?(\d{1,3}) ?(mm)?$/.exec(x);
    if (bare) {
      var bn = Number(bare[1]);
      x = (/^m/.test(x) || (bn <= 12 && !/mm/.test(x)) ? "m" + bn : bn + "mm") +
          " " + (((ctx.slots || {}).type) || "").toLowerCase();
    }
    var a = attrs(x);
    var app = detectApp(x);
    // "what screw goes with a nut" - pairing knowledge
    var pairing = /\bnuts?\b/.test(x) && /\b(screws?|bolts?)\b/.test(x) &&
                  /\b(with|go|goes|pair|match|fit|suit|for)\b/.test(x);
    var s0 = ctx.slots || {};
    var merged = {
      grade: a.grade || s0.grade || null,
      size: a.size || s0.size || null,
      length: a.length != null ? a.length : (s0.length != null ? s0.length : null),
      env: a.env || (app && app.env) || s0.env || null,
      type: a.type || s0.type || null,
    };
    ctx.slots = merged;
    // Know the type but nothing about where it's going: ask one targeted question
    if (merged.type && !merged.env && !merged.grade && !merged.size && !app && !pairing && !ctx.askedEnv) {
      ctx.askedEnv = true;
      return { text: pick("askEnv", { type: merged.type.toLowerCase() }),
               chips: ["Indoor", "Outdoor / garden", "Marine / coastal"] };
    }
    var PAIR_NOTE = "Only machine threads take a nut - so you want a machine screw or bolt in the same M size as the nut (an M4 nut fits an M4 machine screw). Wood screws and self-tappers won't take a nut.";
    var searchText = x + " " + (app ? app.terms + " " : "") + (pairing ? "machine screws " : "") +
                     (merged.type || "") + " " + (merged.size || "");
    var recs = rank(merged, searchText);
    if (recs.length === 0) {
      var pre = (pairing ? PAIR_NOTE + "\n\n" : "") + (app ? fill(app.note) + "\n\n" : "");
      return { text: pre + pick("productMore") };
    }
    ctx.lastRecs = { recs: recs, slots: merged, app: app || null };
    var marine = (merged.env === "marine" || merged.env === "corrosive");
    var lead = marine ? pick("marineLead", { env: merged.env }) : pick("productLead");
    if (app) lead = fill(app.note) + "\n\n" + lead;
    if (pairing) lead = PAIR_NOTE + "\n\n" + lead;
    return { text: lead, cards: recs, chips: ["A2 vs A4?", "Delivery info"] };
  }

  // ---- UI (Shadow DOM, accessible, lazy) ----
  var reduce = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
  var host, root, panel, msgs, input, launcher, open = false;

  var side = cfg.position === "bottom-left" ? "left:22px" : "right:22px";
  var STYLE =
    ":host{all:initial;--ac:" + cfg.accent + ";--ink:#1b1d22;--muted:#6b7280}" +
    "*{box-sizing:border-box;font-family:-apple-system,'Segoe UI',Roboto,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased}" +
    // Icon-only launcher. The labelled pill was 195px wide and overlapped the
    // TrustedSite badge pinned to the bottom-right corner. A 56px circle sits
    // clear of it, and bottom:76px keeps the whole button above the badge
    // (which occupies roughly the bottom 25px on the right). The label lives on
    // aria-label and title instead, so nothing is lost for assistive tech.
    ".l{position:fixed;bottom:76px;" + side + ";display:flex;align-items:center;justify-content:center;width:56px;height:56px;background:var(--ac);color:#fff;border:0;border-radius:50%;padding:0;cursor:pointer;z-index:2147483000;box-shadow:0 8px 24px rgba(0,0,0,.18),0 2px 6px rgba(0,0,0,.10);transition:transform .18s ease,box-shadow .18s ease}" +
    ".l:hover{transform:translateY(-2px);box-shadow:0 12px 30px rgba(0,0,0,.24)}.l svg{width:26px;height:26px;flex:none}" +
    ".p{position:fixed;bottom:24px;" + side + ";width:min(384px,calc(100vw - 32px));height:min(620px,calc(100vh - 120px));background:#fff;border-radius:18px;overflow:hidden;display:flex;flex-direction:column;z-index:2147483001;box-shadow:0 24px 60px rgba(17,20,28,.22),0 6px 16px rgba(17,20,28,.10);opacity:0;transform:translateY(12px) scale(.98);pointer-events:none;transition:opacity .2s ease,transform .2s ease}" +
    ".p.o{opacity:1;transform:none;pointer-events:auto}" +
    ".hd{background:var(--ac);color:#fff;padding:14px 16px;display:flex;align-items:center;gap:11px}" +
    ".hd .av{width:38px;height:38px;border-radius:50%;background:rgba(255,255,255,.18);display:flex;align-items:center;justify-content:center;flex:none}.hd .av svg{width:21px;height:21px}" +
    ".hd .ti{flex:1;min-width:0;line-height:1.25}.hd .ti b{display:block;font-size:15px;font-weight:600;letter-spacing:.2px}" +
    ".hd .ti span{font-size:11.5px;opacity:.92;display:flex;align-items:center;gap:5px}.hd .d{width:7px;height:7px;border-radius:50%;background:#5fe3a1;box-shadow:0 0 0 3px rgba(95,227,161,.25)}" +
    ".hd .x{background:transparent;border:0;color:#fff;cursor:pointer;width:30px;height:30px;border-radius:8px;display:flex;align-items:center;justify-content:center;opacity:.9}.hd .x:hover{background:rgba(255,255,255,.16);opacity:1}.hd .x svg{width:18px;height:18px}" +
    ".bd{flex:1;overflow-y:auto;padding:16px 14px;display:flex;flex-direction:column;gap:12px;background:#f6f6f7}" +
    ".bd::-webkit-scrollbar{width:8px}.bd::-webkit-scrollbar-thumb{background:#d9d9dd;border-radius:8px}" +
    "@keyframes fi{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:none}}" +
    ".b{max-width:86%;padding:10px 13px;font-size:13.5px;line-height:1.55;border-radius:16px;animation:fi .22s ease;white-space:pre-line}" +
    ".b.a{background:#fff;border:1px solid #ededf0;color:var(--ink);align-self:flex-start;border-bottom-left-radius:5px;box-shadow:0 1px 2px rgba(0,0,0,.04)}" +
    ".b.u{background:var(--ac);color:#fff;align-self:flex-end;border-bottom-right-radius:5px}" +
    ".card{align-self:stretch;border:1px solid #ededf0;border-radius:14px;padding:13px;background:#fff;box-shadow:0 1px 3px rgba(0,0,0,.05);animation:fi .22s ease}" +
    ".card .t{font-weight:600;font-size:13.5px;line-height:1.35;color:var(--ink);margin:0 0 8px}" +
    ".card .m{display:flex;gap:6px;flex-wrap:wrap;margin:0 0 11px}" +
    ".chip{font-size:11px;font-weight:600;letter-spacing:.3px;padding:3px 9px;border-radius:6px}.chip.g{background:#23262d;color:#fff}.chip.s{background:#f0f0f2;color:#555}" +
    ".card a{display:inline-flex;align-items:center;gap:6px;font-size:12.5px;font-weight:600;color:var(--ac);text-decoration:none;padding:7px 13px;border:1px solid var(--ac);border-radius:10px;transition:background .15s ease,color .15s ease}.card a:hover{background:var(--ac);color:#fff}.card a svg{width:14px;height:14px}" +
    ".src{display:flex;align-items:center;gap:5px;font-size:11px;color:var(--muted);margin-top:-4px}.src svg{width:13px;height:13px;opacity:.7;flex:none}" +
    ".sg{display:flex;flex-wrap:wrap;gap:7px;margin-top:2px}.sg button{font-size:12.5px;font-weight:500;padding:8px 13px;border:1px solid #e2e2e6;border-radius:999px;background:#fff;cursor:pointer;color:var(--ink);transition:all .15s ease}.sg button:hover{border-color:var(--ac);color:var(--ac)}" +
    ".em{display:inline-flex;align-items:center;gap:7px;margin-top:6px;font-size:13px;font-weight:600;padding:9px 14px;border-radius:10px;background:var(--ac);color:#fff;text-decoration:none}.em:hover{filter:brightness(.94)}.em svg{width:16px;height:16px}" +
    ".ft{border-top:1px solid #eee;padding:11px 12px;display:flex;gap:9px;align-items:center;background:#fff}" +
    ".ft input{flex:1;height:40px;border:1px solid #e3e3e7;border-radius:12px;padding:0 13px;font-size:13.5px;color:var(--ink);outline:none;transition:border .15s ease,box-shadow .15s ease}.ft input::placeholder{color:#9aa0a8}.ft input:focus{border-color:var(--ac);box-shadow:0 0 0 3px rgba(229,96,31,.14)}" +
    ".send{flex:none;width:40px;height:40px;border-radius:12px;border:0;background:var(--ac);color:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center}.send:hover{filter:brightness(.94)}.send svg{width:18px;height:18px}";

  var ICN = {
    chat: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M21 11.5a8.4 8.4 0 0 1-8.5 8.5 9 9 0 0 1-3.8-.8L3 21l1.3-3.9A8.4 8.4 0 0 1 3.5 11.5 8.5 8.5 0 0 1 12 3a8.5 8.5 0 0 1 9 8.5z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    bot: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 5.5h16a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H9l-4 3.5V15.5H4a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><circle cx="9" cy="10.5" r="1.1" fill="currentColor"/><circle cx="12" cy="10.5" r="1.1" fill="currentColor"/><circle cx="15" cy="10.5" r="1.1" fill="currentColor"/></svg>',
    x: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    send: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    arrow: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    doc: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M14 3H7a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7l-4-4z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><path d="M14 3v4h4" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/></svg>',
    mail: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" stroke-width="1.8"/><path d="M4 7l8 6 8-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  };

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }

  function el(tag, cls, txt) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (txt != null) e.textContent = txt;
    return e;
  }
  function scroll() { msgs.scrollTop = msgs.scrollHeight; }

  function addUser(t) { var b = el("div", "b u", t); msgs.appendChild(b); scroll(); }
  function addBot(res) {
    var b = el("div", "b a", res.text);
    msgs.appendChild(b);
    if (res.source) {
      var sr = el("div", "src");
      sr.innerHTML = ICN.doc + "<span>" + esc("Source: " + res.source) + "</span>";
      msgs.appendChild(sr);
    }
    if (res.email) {
      var a = el("a", "em");
      a.innerHTML = ICN.mail + "<span>Email " + esc(cfg.email) + "</span>";
      var mailto = "mailto:" + cfg.email + "?subject=" + encodeURIComponent("Simfix store enquiry");
      if (res.mailtoBody) mailto += "&body=" + encodeURIComponent(res.mailtoBody);
      a.href = mailto;
      msgs.appendChild(a);
    }
    if (res.cards) {
      for (var i = 0; i < res.cards.length; i++) {
        var p = res.cards[i].p;
        var c = el("div", "card");
        c.appendChild(el("p", "t", p.title));
        var meta = el("div", "m");
        meta.appendChild(el("span", "chip g", p.grade === "A4" ? "A4 / 316" : "A2 / 304"));
        if (p.sizeMetric) meta.appendChild(el("span", "chip s", p.sizeMetric));
        c.appendChild(meta);
        var link = el("a", null);
        link.innerHTML = "<span>View product</span>" + ICN.arrow;
        link.href = p.url; link.target = "_top";
        c.appendChild(link);
        msgs.appendChild(c);
      }
    }
    if (res.chips && res.chips.length) suggestions(res.chips);
    scroll();
  }
  function suggestions(items) {
    var wrap = el("div", "sg");
    items.forEach(function (q) {
      var btn = el("button", null, q);
      btn.addEventListener("click", function () { handle(q); });
      wrap.appendChild(btn);
    });
    msgs.appendChild(wrap); scroll();
  }

  function handle(text) {
    text = (text || "").trim();
    if (!text) return;
    addUser(text);
    // Waits on the catalogue rather than a fixed delay, so a product question asked
    // immediately after opening still ranks against the full range. In practice the
    // load started when the panel opened and this resolves right away.
    var t0 = Date.now();
    catalogueReady(function () {
      var wait = Math.max(0, 150 - (Date.now() - t0));
      setTimeout(function () { addBot(answer(text)); }, wait);
    });
  }

  function build() {
    // Load Bebas Neue (matches the Simfix storefront display headings) into the document
    // so it's available inside the widget's shadow root.
    if (!document.getElementById("simfix-bebas")) {
      var fl = document.createElement("link");
      fl.id = "simfix-bebas";
      fl.rel = "stylesheet";
      fl.href = "https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap";
      (document.head || document.documentElement).appendChild(fl);
    }
    host = document.createElement("div");
    host.id = "simfix-assistant-root";
    // Force the host visible with high-priority inline styles so storefront/theme CSS
    // (e.g. rules hiding bare <div>s) cannot hide our widget. Append to <html> to dodge
    // any `body > div` rules entirely.
    host.style.setProperty("display", "block", "important");
    host.style.setProperty("visibility", "visible", "important");
    host.style.setProperty("opacity", "1", "important");
    (document.documentElement || document.body).appendChild(host);
    root = host.attachShadow({ mode: "open" });
    var st = document.createElement("style"); st.textContent = STYLE; root.appendChild(st);

    launcher = el("button", "l");
    launcher.setAttribute("aria-label", cfg.label);
    launcher.setAttribute("title", cfg.label);
    launcher.setAttribute("aria-expanded", "false");
    // Icon only: the visible label is dropped in favour of aria-label + title.
    launcher.innerHTML = ICN.chat;
    launcher.addEventListener("click", toggle);
    root.appendChild(launcher);

    panel = el("div", "p");
    panel.setAttribute("role", "dialog");
    panel.setAttribute("aria-label", cfg.name);
    if (reduce) panel.style.transition = "none";
    panel.innerHTML =
      '<div class="hd"><div class="av">' + ICN.bot + "</div>" +
      '<div class="ti"><b>' + esc(cfg.name) + '</b><span><i class="d"></i>Online</span></div>' +
      '<button class="x" aria-label="Close">' + ICN.x + "</button></div>" +
      '<div class="bd" role="log" aria-live="polite"></div>' +
      '<div class="ft"><input type="text" aria-label="Message Simfix" placeholder="Message Simfix"/>' +
      '<button class="send" aria-label="Send">' + ICN.send + "</button></div>";
    root.appendChild(panel);
    msgs = panel.querySelector(".bd");
    input = panel.querySelector("input");
    panel.querySelector(".x").addEventListener("click", close);
    panel.querySelector(".send").addEventListener("click", submit);
    input.addEventListener("keydown", function (e) { if (e.key === "Enter") submit(); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && open) close(); });

    addBot({ text: cfg.welcome });
    suggestions([
      "Help me pick a fastener",
      "A2 vs A4?",
      "Something for outdoor use",
      "Delivery & returns",
    ]);
  }

  function submit() { var t = input.value; input.value = ""; handle(t); }
  function setOpen(o) {
    open = o; panel.classList.toggle("o", o);
    launcher.style.display = o ? "none" : "flex";
    launcher.setAttribute("aria-expanded", o ? "true" : "false");
    if (o) {
      catalogueReady();
      setTimeout(function () { input && input.focus(); }, 0);
    }
  }
  function toggle() { setOpen(!open); }
  function close() { setOpen(false); launcher.focus(); }

  function init() { build(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
